import { render, staticRenderFns } from "./AccountAllocation.vue?vue&type=template&id=1565754d"
import script from "./AccountAllocation.vue?vue&type=script&lang=js"
export * from "./AccountAllocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports